<template>
  <v-card>
    <v-card-title :class="compact ? '' : 'white-space-word-break'" style="line-height: 1.3em">
      {{ rid.info?.title ?? rid.title }}
    </v-card-title>

    <v-card-subtitle opacity="100" class="my-1">
      <rid-chips
        :status="rid.status"
        :source="rid.source"
        :status-filter="statusFilter"
        :source-filter="sourceFilter"
      />
    </v-card-subtitle>

    <v-card-text class="d-flex flex-column ga-1">
      <rid-field :value="rid.kind" label="Вид РИД" icon="mdi-robot-industrial" />
      <rid-field
        v-if="rid.status === statusFilter.PENDING"
        :value="formatDate(rid.plannedAt) + ' (' + relativeTimeFromUnix(rid.plannedAt) + ')'"
        label="Плановая дата создания"
        icon="mdi-calendar-month-outline"
      />
      <rid-application
        v-if="rid.status === statusFilter.APPLIED"
        :compact="compact"
        :application="rid.info.application"
      />
      <rid-patent
        v-if="rid.status === statusFilter.REGISTERED"
        :compact="compact"
        :patent="rid.info.patent"
        :application="rid.info.application"
      />
      <rid-people
        v-if="rid.status !== statusFilter.PENDING && !compact"
        :authors="rid.info?.authors"
        :holders="rid.info?.holders"
      />
    </v-card-text>

    <div class="d-flex justify-center mb-2">
      <modal-confirm
        v-if="rid.status === statusFilter.PENDING && rid.source !== sourceFilter.UNPLANNED"
        label="Подать сведения"
        @accept="emit('realize', rid.pointHumanId)"
      >
        <p>
          Вы будете перенаправлены на форму подачи данных о плановом РИД, после заполнения которой
          информация будет проверена ответственным менеджером и Вашем личном кабинете отразится
          актуальный статус РИД.
        </p>
        <v-card flat class="pa-2 mb-3">{{ rid.info?.title ?? rid.title }}</v-card>
        <strong>Вы уверены, что хотите подать сведения о плановом РИД?</strong>
      </modal-confirm>
      <modal-confirm
        v-else
        label="Обновить сведения"
        @accept="emit('actualize', rid.type, rid.planCode, rid.code)"
      >
        <p>
          В рамках текущего проекта будет инициирована задача на обновление сведений о ранее
          поданном РИД или заявке.
        </p>
        <p>
          Это позволит внести изменения и дополнения в сведения о результате интеллектуальной
          деятельности или связанной с ним заявке.
        </p>
        <v-card flat class="pa-2 mb-3">{{ rid.info?.title ?? rid.title }}</v-card>
        <strong>Вы уверены, что хотите инициировать обновление сведений о РИД?</strong>
      </modal-confirm>
    </div>
  </v-card>
</template>

<script setup>
import moment from 'moment'
import RidChips from '@/components/Rid/RidChips.vue'
import RidPeople from '@/components/Rid/RidPeople.vue'
import RidApplication from '@/components/Rid/RidApplication.vue'
import RidPatent from '@/components/Rid/RidPatent.vue'
import RidField from '@/components/Rid/RidField.vue'
import ModalConfirm from '@/components/Rid/ModalConfirm.vue'
moment.locale('ru')

const emit = defineEmits(['realize', 'actualize'])

defineProps({
  rid: {
    type: Object,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  sourceFilter: {
    type: Object,
    required: true,
  },
  statusFilter: {
    type: Object,
    required: true,
  },
})

function relativeTimeFromUnix(unixSeconds) {
  const date = moment.unix(unixSeconds)
  const now = moment()

  if (date.isBefore(now)) {
    return `просрочено на ${date.toNow(true)}`
  } else {
    return `через ${date.fromNow(true)}`
  }
}

const formatDate = (unixtime) => moment.unix(unixtime).format('YYYY-MM-DD')
</script>

<style scoped lang="scss">
.v-card {
  border: 1px solid #aaa;
}
</style>
